import { Tag } from "antd";
import { RESEARCH_TYPE } from "./consts";
import englishJson from "./language/leStudy/english.json";
import spanishJson from "./language/leStudy/spanish.json";

/**
 * Converts a string to camelCase
 * @param {string} str - The string to convert
 * @returns {string} - The camelCase version
 */
const toCamelCase = (str) => {
  if (!str) return str;
  return str
    .replace(/[^\w\s]/g, ' ') // Replace punctuation with spaces
    .split(/\s+/) // Split by spaces
    .map((word, index) => {
      if (index === 0) {
        return word.toLowerCase();
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join('');
};

/**
 * Translates API messages based on the selected language
 * @param {string} apiMessage - The message from the API
 * @param {string} language - The language preference ("English" or "Spanish")
 * @returns {string} - The translated message or original if translation not found
 */
export const translateApiMessage = (apiMessage, language = "English") => {
  if (!apiMessage) return apiMessage;

  // Get the appropriate language JSON
  const formData =
    RESEARCH_TYPE == "LE Study"
      ? language == "English"
        ? englishJson
        : spanishJson
      : englishJson;

  // Get the API messages object
  const apiMessages = formData?.page?.apiMessages || {};

  // Convert API message to camelCase for lookup
  const camelCaseKey = toCamelCase(apiMessage);

  // Return translated message if found, otherwise return original
  return apiMessages[camelCaseKey] || apiMessage;
};

const helperFunctions = {
  getColor: function (value) {
    let colorClass = "zero_color";
    if (value == "1") {
      colorClass = "one_color";
    } else if (value == "2") {
      colorClass = "two_color";
    } else if (value == "3") {
      colorClass = "three_color";
    } else if (value == "4") {
      colorClass = "four_color";
    }
    return colorClass;
  },
  getColorForCpibForm: function (value) {
    let colorClass = "zero_color";
    if (value == "0") {
      colorClass = (
        <>
          <Tag className="tag-font-size-15" color="green">
            Very much
          </Tag>{" "}
          <span className="tag-font-size-15">(0)</span>
        </>
      );
    } else if (value == "1") {
      colorClass = (
        <>
          <Tag className="tag-font-size-15" color="cyan">
            Quite a bit
          </Tag>{" "}
          <span className="tag-font-size-15">(1)</span>
        </>
      );
    } else if (value == "2") {
      colorClass = (
        <>
          <Tag className="tag-font-size-15" color="purple">
            A little
          </Tag>{" "}
          <span className="tag-font-size-15">(2)</span>
        </>
      );
    } else if (value == "3") {
      colorClass = (
        <>
          <Tag className="tag-font-size-15" color="magenta">
            Not at all
          </Tag>{" "}
          <span className="tag-font-size-15">(3)</span>
        </>
      );
    }
    return colorClass;
  },
  get_road_text: function (value) {
    let text = "";
    if (value == "0") {
      text = "Unable to perform";
    } else if (value == "1") {
      text = "Abnormal: able to perform but with difficulty";
    } else if (value == "2") {
      text = "Normal: able to perform without difficulty";
    }
    return text;
  },
};

export default helperFunctions;
